import React from "react";
import { useAppSelector } from "@/store/store";
import { useHistory } from "react-router-dom";
import Toolbar from "@mui/material/Toolbar";
import DefaultAppBar from "../../components/DefaultAppBar";
import Typography from "@mui/material/Typography";
import { fullAddress } from "../../functions/users";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { IconButton } from "@mui/material";

function TicketDetailAppBar() {
  const history = useHistory();
  const currentEstate = useAppSelector(({ estates }) => estates.currentEstate);
  const addressText = fullAddress(currentEstate.address);

  return (
    <DefaultAppBar>
      <Toolbar>
        <IconButton onClick={() => history.goBack()}>
          <ArrowBackIosIcon style={{ color: "white" }} />
        </IconButton>

        <div>
          <Typography color="inherit">{currentEstate.name}</Typography>
          <Typography variant="caption" color="inherit">
            {addressText}
          </Typography>
        </div>
      </Toolbar>
    </DefaultAppBar>
  );
}

export default TicketDetailAppBar;
